import AsyncPage from 'pages/AsyncPage'

import universal from 'react-universal-component'
const component = universal(props => import('./CreateGroupBasicsPage'))

export default new AsyncPage({
  pageComponent: component
})
